function addSessionStorage(key,value){
  let session = sessionStorage.cotizar != undefined ? sessionStorage.cotizar : {};
  if(typeof session == "string"){ session = JSON.parse(session); }
  session[key] = value;
  sessionStorage.setItem('cotizar',JSON.stringify(session));
  return true;
}

function getSessionStorage(key){
  let session = sessionStorage.cotizar;
  if(session != undefined){
      let values = JSON.parse(session);
      return values[key];
  }
}

function getFieldsCotizar(){
    return ['servicio-diseno-desarrollo','servicio-marketing','servicio-investigacion','tamano-proyecto','contenido','imagenes','idioma'];
}

function getFieldsInformacion(){
    return ['nombre','apellido','email','telefono','empresa'];
}

function getFieldsDetalles(){
    return ['tiempo-proyecto','presupuesto','mensaje'];
}

/**
Nomaliza la pagina cotizar
**/
function checkPageCotizar(){

  if(getSessionStorage('servicio-diseno-desarrollo')){
    for(let i of getSessionStorage('servicio-diseno-desarrollo')){
      $(".servicio-diseno-desarrollo[value="+i+"]").prop('checked',true);
    }
  }

  if(getSessionStorage('servicio-marketing')){
    for(let i of getSessionStorage('servicio-marketing')){
      $(".servicio-marketing[value="+i+"]").prop('checked',true);
    }
  }

  if(getSessionStorage('servicio-investigacion')){
    for(let i of getSessionStorage('servicio-investigacion')){
      $(".servicio-investigacion[value="+i+"]").prop('checked',true);
    }
  }

  if(getSessionStorage('servicio-investigacion')){
    for(let i of getSessionStorage('servicio-investigacion')){
      $(".servicio-investigacion[value="+i+"]").prop('checked',true);
    }
  }

  if(getSessionStorage('tamano-proyecto')){
    $("select[name=tamano-proyecto]").val(getSessionStorage('tamano-proyecto'));
  }

  if(getSessionStorage('contenido')){
    $("input[name=contenido][value="+getSessionStorage('contenido')+"]").prop('checked',true);
  }

  if(getSessionStorage('imagenes')){
    $("input[name=imagenes][value="+getSessionStorage('imagenes')+"]").prop('checked',true);
  }

  if(getSessionStorage('idioma')){
    $("input[name=idioma][value="+getSessionStorage('idioma')+"]").prop('checked',true);
  }
}

/**
Normaliza la pagina informacion solicitante
**/
function checkPageInformacion(){
  let fields = getFieldsInformacion();

  for(let field of fields){
    if(getSessionStorage(field)){
      $("[name="+field+"]").val(getSessionStorage(field));
    }
  }
}


/**
Normaliza la pagina detalles del proyecto
**/
function checkPageDetalles(){
  let fields = getFieldsDetalles();

  for(let field of fields){
    if(getSessionStorage(field)){
      $("[name="+field+"]").val(getSessionStorage(field));
    }
  }
}

$(function(){

  if($('#page-cotizar-id').length > 0){
    checkPageCotizar();
  }

  if($('#page-informacion-solicitante-id').length > 0){
    checkPageInformacion();
  }

  if($('#page-detalles-proyecto-id').length > 0){
    checkPageDetalles();
  }

  /***
  guarda el formulario pagina cotizar
  **/
  $('#next-page-cotizar').on('click',function(){
    let fields = getFieldsCotizar();
    let data = {};

    if($(".servicio-diseno-desarrollo:checked").length == 0 &&
       $(".servicio-marketing:checked").length == 0 &&
       $(".servicio-investigacion:checked").length == 0){
         $('.module-services').addClass('form-control--invalid');
         $('b.form-control__text').show();
         return false;
       }else{
          $('.module-services').removeClass('form-control--invalid');
          $('b.form-control__text').hide();
       }


    data['servicio-diseno-desarrollo'] = [];
    $(".servicio-diseno-desarrollo:checked").filter((i)=>{
        data['servicio-diseno-desarrollo'].push($(".servicio-diseno-desarrollo:checked")[i].value);
    });

    data['servicio-marketing'] = [];
    $(".servicio-marketing:checked").filter((i)=>{
        data['servicio-marketing'].push($(".servicio-marketing:checked")[i].value);
    });

    data['servicio-investigacion'] = [];
    $(".servicio-investigacion:checked").filter((i)=>{
        data['servicio-investigacion'].push($(".servicio-investigacion:checked")[i].value);
    });

    data["tamano-proyecto"] = $("select[name=tamano-proyecto]").val();
    data["contenido"] = $("input[name=contenido]:checked").val();
    data["imagenes"] = $("input[name=imagenes]:checked").val();
    data["idioma"] = $("input[name=idioma]:checked").val();

    for(let i in data){
      addSessionStorage(i,data[i]);
    }
  });

  /***
  guarda el formulario pagina informacion solicitante
  **/
  $('#next-page-informacion').on('click',function(){
    let fields = getFieldsInformacion();
    let data = {};

    for(let field of fields){
      data[field] = $('[name='+field+']').val();
    }

    for(let i in data){
      addSessionStorage(i,data[i]);
    }
  });

  /***
  guarda el formulario pagina detalles proyectos
  **/
  $('#next-page-detalles-proyectos').on('click',function(){
    let fields = getFieldsDetalles();
    let data = {};

    for(let field of fields){
      data[field] = $('[name='+field+']').val();
    }

    for(let i in data){
      addSessionStorage(i,data[i]);
    }
  });

  $('#form-cotizador-send').submit(function(){
      sessionStorage.clear();
  });

  /***
 guarda servicios del proyecto para cotizador - single proyecto
  **/
  $('#get-servicios').on('click',function(event){
    var $item = $(event.currentTarget);
    var $form = $item.parents('form');
    var idform = $form.attr('id');

    let fields = getFieldsCotizar();
    let data = {};


    data['servicio-diseno-desarrollo'] = [];
    $(".servicio-diseno-desarrollo").filter((i)=>{
        data['servicio-diseno-desarrollo'].push($('#' + idform + " .servicio-diseno-desarrollo")[i].value);
    });

    data['servicio-marketing'] = [];
    $(".servicio-marketing").filter((i)=>{
        data['servicio-marketing'].push($('#' + idform + " .servicio-marketing")[i].value);
    });

    data['servicio-investigacion'] = [];
    $(".servicio-investigacion").filter((i)=>{
        data['servicio-investigacion'].push($('#' + idform + " .servicio-investigacion")[i].value);
    });

    for(let i in data){
      addSessionStorage(i,data[i]);
    }

  });

  /***
  guarda servicio especifico a cotizar - single servicio
  **/
  $('.get-servicio').on('click',function(event){
    var data = [];
    var $item = $(this);
    var value = $item.data('servicioespecifico');
    var servicio = $item.data('serviciogeneral');

    if(servicio == "servicio-marketing"){
       data['servicio-marketing'] = [];
       data['servicio-marketing'].push(value);
    }

    if(servicio == "servicio-diseno-desarrollo"){
       data['servicio-diseno-desarrollo'] = [];
       data['servicio-diseno-desarrollo'].push(value);

    }

    if(servicio == "servicio-investigacion"){
       data['servicio-investigacion'] = [];
       data['servicio-investigacion'].push(value);
    }

    for(let i in data){
      addSessionStorage(i,data[i]);
    }

  });

});
